import IssuePage from './IssuePage';

export default IssuePage;
